import React from 'react'
import { Basket } from 'views/purchase'

export const BasketPage = () => {
  return <Basket />
}
